import { Flex, Skeleton } from 'antd';

export const PageSkeleton = () => {
  return (
    <Flex gap={48} vertical>
      <Flex align="center">
        <Flex
          style={{
            flex: '1 1 auto',
            minWidth: 0,
          }}
        >
          <Skeleton
            active
            paragraph={false}
            style={{
              width: '20%',
            }}
          />
        </Flex>
        <Flex gap={16} align="center"></Flex>
      </Flex>
      <Skeleton active />
    </Flex>
  );
};
